import { Display, List } from "stentor-models";

export function isList(display: Display): display is List {
    return !!display && ((display as List).type === "LIST");
}